/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class LocaTestEnvironment extends LiveEnvironment {
    public static LOCA_TEST_ENVIRONMENT_ID: string = "LocaTestEnvironment";

    constructor() {
        super(LocaTestEnvironment.LOCA_TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();

        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-locatest/{gameId}/{networkVersion}/{networkId}.xml";
        }

        this._countryConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-locatest/country/{gameId}/{countryVersion}/country.xml";
        this._zoneCapacitiesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config/network/status/{gameId}/zone_capacities.json";
        this._maintenanceConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config/network/status/{gameId}/maint.json";
        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-locatest/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";
        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-locatest/language/{gameId}/cldr";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-locatest/version/{gameId}/version.json";

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-locatest/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-locatest/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";
    }

    public isSupported(): boolean {
        return this._data.globals.isLocaTest;
    }
}
